/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, embedCorners } from 'utils/styles';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// IMAGE 2 ANSWER STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
	uniqueanswer: {
		display: 'block',
		extend: embedCorners,
		position: 'relative',
		width: '100%',
		height: '95%'
	},
	graphic: {
		// backgroundImage - dynamic, comes from component which comes from settings
		backgroundColor: 'transparent',
		backgroundPosition: '50% 0%',
		backgroundRepeat: 'no-repeat',
		backgroundSize: 'cover',
		borderRadius: 'inherit',
		display: 'inline-block',
		verticalAlign: 'bottom',
		textAlign: 'center',
		width: '100%',
		height: '100%'
	}
};